var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.232 1.887a7.55 7.55 0 0 0 .276 1.588l-.735.736a9.09 9.09 0 0 1-.466-2.324h.925Zm6.046 7.37a7.82 7.82 0 0 0 1.594.276v.914a9.456 9.456 0 0 1-2.33-.46l.736-.73ZM2.821.661H.675a.615.615 0 0 0-.613.613c0 5.758 4.666 10.424 10.423 10.424a.615.615 0 0 0 .613-.614v-2.14a.615.615 0 0 0-.613-.613c-.76 0-1.502-.122-2.189-.35a.628.628 0 0 0-.625.147L6.322 9.48a9.288 9.288 0 0 1-4.04-4.04l1.348-1.35a.615.615 0 0 0 .154-.625 6.965 6.965 0 0 1-.35-2.189.615.615 0 0 0-.613-.613Z",
    fill: "#004152"
  })));
};
export default SvgPhone;